<template>
  <div class="container">
    <div id="mapDiv" class="map_marker"></div>
    <div class="bg"></div>
   <div class="top" style="display: flex;justify-content: space-between;">
      <div style="width:100%;max-width:1200px;margin:0px auto;">
        <div style="margin-top: 18px;color: white;margin-right: 20px;position: absolute;right: 0px;font-size: 15px;">
          <router-link :to="{name:'Complain_info'}" style="color: white;">投诉建议</router-link>
        </div>
        <div class="logo">
          <router-link to='/'><img src="../assets/logo.png"></router-link>
        </div>
        <ul class="pc pcnav">
          <li>
            <router-link :to="{name:'Common_product'}">产品介绍</router-link>
          </li>
          <li>
            <router-link :to="{name:'Common_introduce'}">公司介绍</router-link>
          </li>
          <li class="currents">
            <router-link :to="{name:'Common_video'}">实时监控</router-link>
          </li>
          <li>
            <!-- <router-link :to="{name:'Common_drew'}">码上有礼</router-link> -->
          </li>
        </ul>
        <div class="qh" style="margin-top: 18px;color: white;margin-right: 20px;">
          <a href="javascript:void(0)" @click="getIntegral" class="integral-btn"><img style="width:20px;vertical-align: text-bottom;" src="../assets/icon-jifen.png"/>积分获取</a>

        </div>
      </div>
    </div>
    <ul class="nav">
      <li style="position: relative">
        <router-link :to="{name:'Common_product'}">产品介绍</router-link>
      </li>
      <li>
        <router-link :to="{name:'Common_introduce'}">企业介绍</router-link>
      </li>
      <li style="position: relative" class="current">
        <router-link :to="{name:'Common_video'}">实时监控</router-link>
        <p class="ui-line"></p>
      </li>
      <li style="position: relative">
        <!-- <router-link :to="{name:'Common_drew'}">码上有礼</router-link> -->
      </li>
    </ul>
    <cube-slide ref="slide" :data="items">
      <cube-slide-item v-for="(item, index) in items">
        <a :href="item.url" class="banner">
          <img :src="item.image" />
        </a>
      </cube-slide-item>
    </cube-slide>
    <div class="store">
      <h3 style="font-weight: bold">农场直播</h3>
      <div v-for="(item,index) in data.suyuanVideoDataNodes" v-if="data.suyuanVideoDataNodes&&data.suyuanVideoDataNodes.length>0">
        <div class="player-container" v-if="show">
          <video-player class="vjs-custom-skin" :options="item.playerOptions"></video-player>
        </div>
        <div class="player-container" v-else>
          <!-- 20210204 zym.so换成zhenyuanma.com -->
          <iframe id="show-iframe" :src="'http://videoflow.cloud.zhenyuanma.com/?deviceCode='+item.deviceId+item.channelNo"></iframe>
        </div>
        <h6 style="padding:12px 0 24px;">{{item.deviceName}}</h6>
      </div>

      <div style="padding: 20px 0;border-bottom: 1px solid #f5f5f5;" v-else>
        <span style="color: #ff0000;">该企业未安装监控</span>
      </div>
    </div>
    <div class="store">
      <h3 style="font-weight: bold">气象数据</h3>
      <div class="weather-content">
        <div class="top">
          <div class="adress">
            <i class="icon-biao"></i>
            <span>{{address}}</span>
          </div>
          <div class="refresh">
            <span>{{weatherData2.updatetime}}</span>
          </div>
        </div>
        <div class="center">
          <div class="head">
            <div class="degree">{{weatherData2.temp}}℃</div>
            <div class="text">
              <i :class="['icon','icon-W'+weatherData2.icon]"></i>
              <span>{{weatherData2.condition}}</span>
            </div>
          </div>
<!--          <div class="tmp">
            <div class="name">空气温度：</div>
            <div class="number">{{weatherData2.temp}}°</div>
          </div> -->
          <div class="desc">
            <div class="list list-flex">
              <div class="item">
                <span class="wea">空气质量</span>
                <span>{{weatherData.value}}</span>
              </div>
              <div class="item">
                <span class="wea">PM2.5</span>
                <span>{{weatherData.pm25}}</span>
              </div>
              <div class="item">
                <span class="wea">PM10</span>
                <span>{{weatherData.pm10}}</span>
              </div>
              <div class="item">
                <span class="wea">臭氧浓度</span>
                <span>{{weatherData.o3C}}</span>
              </div>
            </div>
          </div>
          <div class="desc future-weather">
            <div class="name">未来6天天气变化</div>
            <div class="list">
              <div class="item" v-for="item in forecast">
                <span class="wea">
                  {{item.tempDay}}℃
                  <em>{{item.conditionDay}}</em>
                </span>

                <span>{{item.predictDate.substr(5,item.predictDate.length-5).replace("-",'月')+"日"}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pc pcintroduce" style="min-height:330px;">
      <h3 style="font-weight: bold">农场直播</h3>
      <div style="padding-top:20px;" v-for="(item,index) in data.suyuanVideoDataNodes" v-if="data.suyuanVideoDataNodes&&data.suyuanVideoDataNodes.length>0">
        <div class="player-container" v-if="show" style="width: 900px; height: 600px;margin: 0 auto;">
          <iframe width="100%" height="100%" id="show-iframe" :src="'http://videoflow.cloud.zhenyuanma.com/?deviceCode='+item.deviceId+item.channelNo+'&height=600'+'&width=100%'"></iframe>
        </div>
        <div class="player-container">
          <iframe width="100%" height="600" id="show-iframe" :src="'http://videoflow.cloud.zhenyuanma.com/?deviceCode='+item.deviceId+item.channelNo+'&height=600'+'&width=100%'"></iframe>
        </div>
        <p style="padding:20px 0 30px;">{{item.deviceName}}</p>
      </div>
      <div style="padding: 20px 0;border-bottom: 1px solid #f5f5f5;" v-else>
        <span style="color: #ff0000;">该企业未安装监控</span>
      </div>
    </div>
    <cp-footer></cp-footer>
  </div>
</template>

<script>
  import cpFooter from "@/views/footer";
  //引入video样式
  import "video.js/dist/video-js.css";
  import "vue-video-player/src/custom-theme.css";
  //引入hls.js
  import "videojs-contrib-hls.js/src/videojs.hlsjs";
  import {
    MP
  } from "../../static/js/map.js";
  export default {
    name: "Common_video",
    components: {
      cpFooter
    },
    data() {
      return {
        randId: "",
        ak: "1sbDPwUb6Deoj0RY404EvzD87U7n8EVd",
        data: [],
        weatherData: {},
        weatherData2: {},
        orgId: "",
        deviceId: "",
        menu_show: false,
        menu_show1: false,
        selectedLabelDefault: "首页",
        tabs: [{
            label: "首页",
            icon: "cubeic-home"
          },
          {
            label: "我的",
            icon: "cubeic-person"
          }
        ],
        items: [{
          url: "",
          image: require("@/assets/bannar2.jpg") //'http://www.zixunxueli.com/img/banner.jpg'
        }],
        forecast: [],
        show: false,
        myGeo: {},
        address: ""
      };
    },
    created() {
      this.num = localStorage.getItem("zymCode");
      this.orgId = localStorage.getItem("orgId");
      this.getLists();
      this.integralData();
    },
    watch: {
      '$route':'integralData'
    },
    methods: {
      getjw(address) {
        this.$axios({
            method: "get",
            url: "portal/third/weather/getLatAndLngByAddress/" + address
          })
          .then(res => {
            if (res.status == 200) {
              let point = {
                lat: res.data.data.lat,
                lng: res.data.data.lng
              }
              this.getData(point);
            }
          })
          .catch(err => {});
      },
      _getMapData() {
        let vue = this;
        this.$axios({
            method: "get",
            url: "portal/suyuan/getCompanyInfo/" + this.num
          })
          .then(res => {
            let address = res.data.data.districtName;
            this.address = address;
            this.getjw(address);
            // 将地址解析结果显示在地图上,并调整地图视野
          })
          .catch(err => {});
      },
      getData(point) {
        let d = {
          lat: point.lat,
          lon: point.lng
        };
        this.$axios({
            method: "post",
            url: "portal/third/weather/briefcondition",
            data: d,
            headers: {
              // 'Authorization': localStorage.getItem('token_type') + localStorage.getItem('access_token'),
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.weatherData2 = res.data.data.data.condition;
            }
          })
          .catch(err => {});

        this.$axios({
            method: "post",
            url: "portal/third/weather/aqi",
            data: d,
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.weatherData = res.data.data.data.aqi;
            }
          })
          .catch(err => {});

        this.$axios({
            method: "post",
            url: "portal/third/weather/briefforecast6days",
            data: d,
            headers: {
              "Content-Type": "application/json"
            }
          })
          .then(res => {
            if (res.data.code == 0) {
              this.forecast = res.data.data.data.forecast;
            }
          })
          .catch(err => {});
      },
      getShow() {
        var userAgent = navigator.userAgent;
        var isOpera = userAgent.indexOf("Opera") > -1;
        let client = {
          weixin: /micromessenger/gi.test(navigator.userAgent),
          app: /cnhnb/gi.test(navigator.userAgent),
          ios: /cnhnb/gi.test(navigator.userAgent) &&
            /ios/gi.test(navigator.userAgent),
          android: /cnhnb/gi.test(navigator.userAgent) &&
            /android/gi.test(navigator.userAgent),
          pc: /windows/gi.test(navigator.userAgent)
        };
        if (client.pc) {
          this.show = false;
        } else {
          this.show = true;
        }
      },
      getStream(deviceId,No) {
        let data = {
          deviceId: deviceId,
          channelNo:No
        };
        this.$axios({
          headers: {
            "Content-Type": "application/json"
          },
          method: "post",
          url: "portal/device/pushStream", //c84419000129,
          data: data
        }).then(res => {
          if (res.data.code == 0 && res.data.data == true) {
            console.log("推流成功");
            let vue = this;
            window.setTimeout(function() {
              vue.getStream(deviceId,No);
            }, 30000);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
    getIntegral() {
      var _this = this;
      var wx_code = _this.$route.query.code;
      var wx_state = _this.$route.query.state;
      if(!wx_code && !wx_state){
        _this.$axios({
          method: "get",
          url: "portal/integral/verify/count/" + _this.num
        })
          .then(res => {
            if(res.data.code == 0){
              if(res.data.data <= 0){
                var appid = "wxfe3edde0e854125b";
                var scope = "snsapi_userinfo";
                var auth_url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope='+scope+'&state='+_this.num+'#wechat_redirect';
                window.location.replace(auth_url);
              }else{
                _this.$Message.error("此积分已被获取!");
              }
            }else{
              _this.$Message.error(res.data.msg);
            }
          })
          .catch(err => {
            alert(err);
            console.log(err);
          });
      }else{
        _this.$Message.error("您已获取积分!");
      }
    },
    integralData(){
      var _this = this;
      var wx_code = _this.$route.query.code;
      var wx_state = _this.$route.query.state;
      if(wx_code && wx_state){
        _this.$axios({
          method: "get",
          url: "portal/integral/verify/count/" + _this.num
        })
          .then(res => {
            if(res.data.code == 0){
              if(res.data.data <= 0){
                _this.$axios({
                  method: "post",
                  url: "portal/integral/add/integral/" + _this.num + "?code="+wx_code,
                  headers: {
                    "Content-Type": "application/json"
                  }
                })
                  .then(res => {
                    if(res.data.code == 0){
                      _this.$Message.success(res.data.msg);
                    }else{
                      _this.$Message.error(res.data.msg);
                    }
                  })
                  .catch(err => {
                    alert(err);
                    console.log(err);
                  });
              }
            }else{
              _this.$Message.error(res.data.msg);
            }
          })
          .catch(err => {
            alert(err);
            console.log(err);
          });
      }
    },
      getLists() {
        this._getMapData();
        this.$axios({
            method: "get",
            url: "portal/suyuan/getMonitorInfo/" + this.orgId
          })
          .then(res => {
            console.log('data', res.data.data);
            if (res.data.data.suyuanVideoDataNodes) {
              this.data = res.data.data;
              this.data.suyuanVideoDataNodes.forEach(o => {
                this.getStream(o.deviceId,o.channelNo);
                o.playerOptions = {
                  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                  autoplay: true, //如果true,浏览器准备好时开始回放。
                  controls: true, //控制条
                  preload: "auto", //视频预加载
                  muted: false, //默认情况下将会消除任何音频。
                  loop: false, //导致视频一结束就重新开始。
                  language: "zh-CN",
                  aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                  fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                  sources: [{
                    headers: {
                      "Access-Control-Alow-Orogin": "*"
                    },
                    type: "application/x-mpegURL",
                    src: o.videoResource
                  }],
                  width: document.documentElement.clientWidth,
                  notSupportedMessage: "此视频暂无法播放，请稍后再试" //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                };
              });
            }
            this.getShow();
          })
          .catch(err => {});
      },
      changeHandler(label) {
        if (label == "我的") {
          this.$router.push({
            path: "Center"
          });
        } else {
          this.$router.push({
            path: "Index"
          });
        }
      },
      showmenu() {
        if (this.menu_show == true) {
          this.menu_show = false;
        } else if (this.menu_show == false) {
          this.menu_show = true;
        }
      },
      showmenu1() {
        if (this.menu_show1 == true) {
          this.menu_show1 = false;
        } else if (this.menu_show1 == false) {
          this.menu_show1 = true;
        }
      }
    }
  };
</script>

<style scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: -1;
    background-color: #f5f5f5;
  }

  h2 {
    color: #45b035;
  }

  .logo {
    width: 25%;
    margin:0px auto;
    line-height: 3rem;
  }

  .logo>a {
    display: inline-block;
    margin-top: 10%;
  }

  .logo img {
    display: block;
    width: 100%;
  }

  .pc {
    display: none;
  }

  .pcintroduce h2 {
    margin: 1rem 0;
  }

  .tab {
    position: fixed;
    width: 100%;
    bottom: 0;
    border-top: 1px solid #f1ebeb;
    background-color: white;
  }

  .nav {
    list-style: none;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f1ebeb;
    background-color: white;
  }

  .nav a {
    color: #333333;
    margin: 12px 0;
    display: inline-block;
  }

  .nav li {
    width: 33%;
    /* padding: 10px 0; */
  }

  .nav li:hover {
    color: #45b035;
  }

  .current a {
    color: #45b035;
  }
.nav .ui-line {
    width: 1.12rem;
    height: 0.1rem;
    background-color: #39BF3E;
    margin: 0px auto;
}
  .banner img {
    width: 100%;
  }

  .introduce {
    text-align: left;
    font-size: 0.8rem;
    color: #999999;
    padding: 0rem 1rem;
    background-color: white;
    margin: 0 0.5rem;
    padding: 0.8rem;
    border-radius: 6px;
    z-index: 1;
    position: relative;
    top: -20px;
  }

  .introduce p {
    margin-bottom: 0.5rem;
  }

  .store {
    background-color: white;
    padding: 0.8rem;
  }

  h3 {
    font-size: 0.9rem;
    text-align: left;
    position: relative;
    padding-left: 10px;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 10px;
  }

  h3:before {
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    width: 3px;
    height: 16px;
  }

  .img_content {
    display: flex;
    margin: 10px 0;
    justify-content: space-around;
  }

  .store p {
    width: 30%;
  }

  .store p img {
    width: 100%;
  }

  .list {
    margin-top: 10px;
  }

  .left_img {
    width: 30%;
  }

  .left_img img {
    width: 100%;
  }

  .list_content {
    display: flex;
    padding: 5px;
    margin-top: 10px;
    box-shadow: 0px 0px 3px #ece6e6;
  }

  .title {
    width: 70%;
    text-align: left;
  }

  h4 {
    font-size: 1rem;
    margin-top: 1.3rem;
    color: #2c3e50;
    margin-left: 1rem;
  }

  .sub {
    font-size: 0.8rem;
    margin-top: 1.3rem;
    color: red;
    margin-left: 1rem;
  }

  .more {
    float: right;
    color: #b8b8b8;
    font-size: 0.8rem;
  }

  .look {
    float: right;
    color: #45b035;
  }

  .it {
    font-size: 0.6rem;
    margin: 5px 0;
    margin-left: 1rem;
  }

  .img_content img {
    border-radius: 6px;
  }

  .ej {
    position: absolute;
    width: 100%;
    background-color: #45b035;
    left: 0;
    top: 38px;
    z-index: 100;
    text-align: right;
  }

  .ej li {
    width: 100%;
    text-align: center;
    color: white;
    border-bottom: 1px solid #fff;
  }

  .ej li a {
    width: 100%;
    text-align: center;
    color: white;
  }

  .ej li a:hover {
    color: white;
  }

  .footer {
    display: block;
    margin-top: 40px;
    text-align: center;
    border-top: 8px solid #45b035;
  }

  .footer p {
    font-size: 14px;
  }

  .footer p>a {
    color: #45b035;
  }

  .video-js {
    width: 100%;
  }

  .tq {
    display: flex;
    flex-flow: wrap row;
    justify-content: space-around;
  }

  .tq p {
    width: 50%;
    font-size: 0.7rem;
    margin-top: 0.4rem;
    text-align: left;
  }

  .tq p span {
    display: inline-block;
    width: 75px;
    text-align: left;
    float: left;
    padding-right: 5px;
  }

  .pcfooter {
    display: none;
  }

  .pcintroduce {
    margin: 2rem auto;
    width: auto;
  }
  .qh{
    display: none;
  }
  .top {
    height: 3rem;
    background:#45b035;
  }
/*  @media screen and (min-width: 1000px) {
    .logo > a{
      margin-top: 10px;
    }
    .qh{
      display: block;
    }
    .tq {
      display: flex;
      flex-flow: wrap row;
      justify-content: space-around;
    }

    .tq p {
      width: 14%;
      font-size: 14px;
      text-align: left;
    }

    .tq p span {
      display: inline-block;
      text-align: right;
      color: #45b035;
      width: 80px;
      text-align: right;
      float: left;
      padding-right: 5px;
    }

    .footer {
      display: none;
    }
    .logo {
      width: 160px;
      margin-left: 20px;
      line-height: 3rem;
      float: left;
    }

    .img {
      width: 40%;
      margin: 0 auto;
    }

    .img img {
      width: 80%;
    }

    .ct {
      width: 88%;
      display: flex;
      margin: 8% auto;
      justify-content: space-around;
    }

    .rt {
      width: 60%;
    }

    .name {
      font-size: 1rem;
    }

    .wz {
      margin-top: 0.7rem !important;
    }

    .it {
      margin-top: 0.8rem !important;
    }

    .qh {
      display: block;
      float: right;
    }

    .pc {
      display: block;
    }

    .pcnav {
      width: 400px;
      display: flex;
      font-size: 18px;
      color: white;
      line-height: 2rem;
      justify-content: space-between;
      float: left;
      margin-left: 100px;
    }

    .pcnav a {
      color: white;
    }

    .nav {
      display: none;
    }

    .introduce {
      display: none;
    }

    .store {
      display: none;
    }

    .pcintroduce {
      margin: 60px auto;
      overflow: hidden;
      overflow-x: auto;
      width: 1200px;
    }

    .pcintroduce h2 {
      text-align: center;
      color: #333;
      padding-bottom: 26px;
      font-size: 32px;
      color: #333;
      background: url(../assets/line_01.png) no-repeat center bottom;
    }

    .bg {
      display: none;
    }

    .nr {
      width: 1200px;
      margin: 20px auto;
      text-align: left;
      line-height: 24px;
      font-size: 14px;
    }

    .jb {
      font-size: 16px;
      text-align: left;
      width: 1200px;
      margin: 10px auto;
      display: flex;
      justify-content: space-between;
    }

    .top {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 1000;
      display: block;
    }

    .pcfooter {
      display: block;
    }

    .nr {
      width: 1200px;
      margin: 20px auto;
    }

    .video-js {
      height: 500px;
    }

    .pcintroduce {
      margin: 10px auto;
    }

    .pcnav .currents {
      position: relative;
    }

    .pcnav .currents:after {
      position: absolute;
      content: "";
      left: 0;
      bottom: 15px;
      height: 3px;
      width: 100%;
      background-color: #fff;
    }
  } */

  .weather-content {
    background-color: #fff;
  }

  .weather-content .top {
    height: 3rem;
    background-color: #45b035;
    display: flex;
  }

  .weather-content .top .adress {
    flex: auto;
    line-height: 3rem;
  }

  .weather-content .top .adress .icon-biao {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../assets/icon-biao.png") no-repeat;
    background-size: 100% 100%;
    margin:0px 0px -5px 5px;
  }

  .weather-content .top .adress span {
    font-size: 20px;
    color: #333;
  }

  .weather-content .top .refresh {
    flex: 1;
    padding: 15px;
    text-align: right;
  }

  .weather-content .top .refresh span {
    font-size: 14px;
    color: #333;
  }

  .weather-content .top .refresh .do {
    text-align: right;
  }

  .weather-content .top .refresh .do .icon-shuaxin {
    position: relative;
    top: 2px;
    display: inline-block;
    width: 14px;
    height: 14px;
  }

  .weather-content .center {
    padding: 0px 15px 15px 15px;
  }

  .weather-content .center .tmp {
    display: flex;
    align-content: flex-start;
    margin-bottom: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
  }

  .weather-content .center .head {
    margin: 20px auto;
  }

  .weather-content .center .head .degree {
    font-size: 42px;
  }

  .weather-content .center .head .text {
    margin-top: 10px;
    display: flex;
  }

  .weather-content .center .head .text i {
    margin-right: 10px;
    width: 32px;
    height: 32px;
  }

  .weather-content .center .head .text span {
    line-height: 32px;
  }

  .weather-content .center .tmp .name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }

  .weather-content .center .tmp .number {
    font-size: 16px;
    color: #666;
  }

  .weather-content .center .desc {
    overflow: hidden;
    margin-bottom: 25px;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
  }

  .weather-content .center .desc .other {
    line-height: 24px;
    font-size: 16px;
    color: #333;
    font-weight: 600;
  }

  .weather-content .center .desc .other span {
    font-size: 16px;
    color: #333;
  }

  .weather-content .center .desc .name {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom:15px;
  }

  .weather-content .center .desc .text {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }

  .weather-content .center .desc .list {
    margin-top: 10px;
    overflow: hidden;
  }

  .weather-content .center .desc .list .item {
    display: inline-block;
    margin: 0px 0px 10px 5px;
  }

  .weather-content .center .desc .list .item span {
    display: block;
    font-size: 14px;
    color: #666;
    text-align: center;
  }

  .weather-content .center .desc .list .item span.wea,
  .weather-content .center .desc .list .item span.wea em {
    font-style: inherit;
    font-size: 16px;
    color: #333;
  }

  .weather-content .center .desc .list .item .icon {
    display: block;
    width: 100%;
    text-align: center;
  }

  .weather-content .center .desc .list .item .icon i {
    display: block;
    margin: 5px auto;
    width: 32px;
    height: 32px;
  }

  .list-flex {
    display: flex;
    align-content: space-between;
  }

  .list-flex .item {
    flex: 1;
  }

  .list-flex .item span {
    font-size: 16px;
  }

  .list-flex .item span.wea {
    margin-bottom: 10px;
  }

  i.icon-W0 {
    background: url("../assets/weather/W0.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W1 {
    background: url("../assets/weather/W1.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W2 {
    background: url("../assets/weather/W2.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W3 {
    background: url("../assets/weather/W3.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W4 {
    background: url("../assets/weather/W4.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W5 {
    background: url("../assets/weather/W5.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W6 {
    background: url("../assets/weather/W6.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W7 {
    background: url("../assets/weather/W7.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W8 {
    background: url("../assets/weather/W8.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W9 {
    background: url("../assets/weather/W9.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W10 {
    background: url("../assets/weather/W10.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W13 {
    background: url("../assets/weather/W13.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W14 {
    background: url("../assets/weather/W14.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W15 {
    background: url("../assets/weather/W15.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W16 {
    background: url("../assets/weather/W16.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W17 {
    background: url("../assets/weather/W17.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W18 {
    background: url("../assets/weather/W18.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W19 {
    background: url("../assets/weather/W19.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W20 {
    background: url("../assets/weather/W20.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W29 {
    background: url("../assets/weather/W29.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W30 {
    background: url("../assets/weather/W30.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W31 {
    background: url("../assets/weather/W31.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W32 {
    background: url("../assets/weather/W32.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W33 {
    background: url("../assets/weather/W33.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W34 {
    background: url("../assets/weather/W34.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W35 {
    background: url("../assets/weather/W35.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W36 {
    background: url("../assets/weather/W36.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W44 {
    background: url("../assets/weather/W44.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W45 {
    background: url("../assets/weather/W45.png") no-repeat;
    background-size: 100%;
  }

  i.icon-W46 {
    background: url("../assets/weather/W46.png") no-repeat;
    background-size: 100%;
  }

  .icon-shuaxin {
    background: url("../assets/icon-shuaxin.png") no-repeat;
    background-size: 100% 100%;
  }

  .weather-content {
    background-color: #fff;
  }

/*  .weather-content .top {
    display: flex;
    align-content: space-between;
  } */

  .integral-btn-wrapper {
    width: 400px;
    padding: 50px;
    background-color: yellow;
  }

  .integral-btn {
    color: white;
    background: #DFAB04;
    height: 58px;
    border: 2px solid #C1AC0E;
    font: 500 20px "Raleway", "Helvetica Neue", Helvetica, Arial, sans-serif;
    padding: 0 10px;
    transition: color 0.1s linear, background-color 0.1s linear, border-color 0.1s linear;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    border-radius: 10px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .integral-btn:hover {
    background: #C1AC0E;
    border-color: #C1AC0E;
  }

  .integral-btn:active {
    background: #45B035;
    border-color: #C1AC0E;
  }
</style>
<style lang="scss">
  #child {
    width: 100%;
  }
  .player-container{
    max-width: 1200px;
    width: 100%;
  }

  .future-weather .list .item{
    width:33.3%;
    margin-left:0px !important;
    margin-bottom:23px !important;
  }
  .future-weather .list .item .wea{
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Common_video.vue